import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { ApplicationStep } from '../../../interfaces/booth-application.interface';

@Component({
  selector: 'app-booth-action-buttons',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (currentStep() !== 'info' && currentStep() !== 'options') {
    <button
      type="button"
      class="text-zinc-800 sb-aggro font-light cursor-pointer flex-1 bg-white rounded-lg border border-zinc-200 p-3 lg:py-2 lg:px-3"
      (click)="prevStep.emit()">
      이전으로
    </button>
    } @if (currentStep() !== 'options') {
    <button
      type="button"
      class="sb-aggro font-light cursor-pointer flex-1 bg-primary-500 text-white rounded-lg border border-zinc-200 p-3 lg:py-2 lg:px-3 disabled:bg-zinc-200 disabled:cursor-not-allowed"
      (click)="nextStep.emit()"
      [disabled]="!isStepValid()">
      다음
    </button>
    } @else {
    <button
      type="button"
      class="text-zinc-800 sb-aggro font-light cursor-pointer flex-1 bg-white rounded-lg border border-zinc-200 p-3 lg:py-2 lg:px-3"
      (click)="prevStep.emit()">
      이전으로
    </button>
    <button
      type="button"
      class="sb-aggro font-light cursor-pointer flex-1 bg-primary-500 text-white rounded-lg border border-zinc-200 p-3 lg:py-2 lg:px-3 disabled:bg-zinc-200 disabled:cursor-not-allowed"
      (click)="submitForm.emit()"
      [disabled]="!canSubmit()">
      확인
    </button>
    }
  `,
  styles: [
    `
      :host {
        display: flex;
        width: 100%;
        gap: 0.75rem; /* gap-3 */
      }
    `,
  ],
})
export class BoothActionButtonsComponent {
  currentStep = input.required<ApplicationStep>();
  isStepValid = input.required<boolean>();
  canSubmit = input.required<boolean>();

  prevStep = output<void>();
  nextStep = output<void>();
  submitForm = output<void>();
}
